import React from 'react';
import { InboxContext } from '@vizsla/providers';
export function useInbox() {
    const context = React.useContext(InboxContext);
    if (!context) {
        throw new Error('useInbox must be used within an InboxProvider');
    }
    return context;
}
